<template lang="pug">
#modal-selecionar-localidade-oncca
    el-dialog.modal-selecionar-localidade-oncca-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='960px'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.territorio.territorioArgentina.modalLocalidadeOncca.selecioneOncca') }}

        .barra-pesquisa(v-if='controleRegistroManual')
            i.el-icon-loading(v-if='pesquisandoOncca')
            i.el-icon-search(v-else)

            input.barra-pesquisa_input(
                v-model='filtro',
                type='text',
                :placeholder='$t("mensagens.territorio.territorioArgentina.modalLocalidadeOncca.placeholderInput")',
                autocomplete='off',
                @keyup.enter='realizarPesquisaOncca',
                @blur='fecharLista'
            )

        .el-collapse-item__container
            el-table(
                ref='tabelaModalSelecionarLocalidadesOnccaRef',
                :data='dadosPaginado',
                style='width: 100%'
            )
                el-table-column(width='50')
                    template(slot-scope='scope')
                        el-radio(v-model='dadoSelecionado', :label='scope.row') &nbsp

                el-table-column(
                    :label='$t("mensagens.territorio.territorioArgentina.modalLocalidadeOncca.codigoOncca")',
                    width='435'
                )
                    template(slot-scope='scope') {{ scope.row.codigoOncca }}

                el-table-column(
                    :label='$t("mensagens.territorio.territorioArgentina.modalLocalidadeOncca.nome")',
                    sortable,
                    prop='nome'
                )
                    template(slot-scope='scope') {{ scope.row.nome }}

        .c-pagination
            el-pagination(
                background,
                :page-size='pageCount',
                :pager-count='pageCount',
                :current-page.sync='paginaAtual',
                layout='prev, pager, next',
                :total='dados.length',
                @current-change='mudarPagina'
            )

        .informar-car-manualmente-car(v-if='!controleRegistroManual')
            el-radio(v-model='dadoSelecionado', label='manual') {{ $t('mensagens.territorio.territorioArgentina.modalLocalidadeOncca.informarManualmente') }}

        footer.my-3(slot='footer')
            el-button(@click='fecharModal')
                | {{ $t('mensagens.comuns.voltar') }}
            div(v-if='!dadoSelecionado')
                el-tooltip(
                    effect='dark',
                    :content='$t("mensagens.territorio.territorioArgentina.modalLocalidadeOncca.selecioneUmOnccaAntesDeConfirmar")',
                    placement='top'
                )
                    el-button(
                        type='primary',
                        @click='retornarDadosSelecionado'
                    )
                        | {{ $t('mensagens.comuns.confirmar') }}
            div(v-else)
                el-button(type='primary', @click='retornarDadosSelecionado')
                    | {{ $t('mensagens.comuns.confirmar') }}
</template>
<script>
export default {
    name: 'ModalSelecionarLocalidadeOnccaAR',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        cpfCnpj: {
            type: String,
            required: false
        },
        dados: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            dadoSelecionado: null,
            paginaAtual: 1,
            pageCount: 5,
            filtro: '',
            pesquisandoOncca: false,
            controleRegistroManual: false
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.dadoSelecionado = null;
        }
    },

    computed: {
        dadosPaginado() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.dados.slice(inicio, fim);
        }
    },

    methods: {
        retornarDadosSelecionado() {
            if (!this.dadoSelecionado) {
                this.alertaParaSelecionarOncca();
            } else if (this.dadoSelecionado === 'manual') {
                this.controleRegistroManual = true;
                this.realizarPesquisaOncca();
                this.dadoSelecionado = null;
                return;
            }

            this.$emit('retornarDadosSelecionados', this.dadoSelecionado);
        },

        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },

        fecharModal() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.territorio.territorioArgentina.modalLocalidadeOncca.alertaDadosNaoSeraoSalvos'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            cancelButtonText: this.$t(
                                'mensagens.territorio.territorioArgentina.modalLocalidadeOncca.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.dadoSelecionado = null;
                        this.controleRegistroManual = false;
                        this.filtro = '';
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },

        alertaParaSelecionarOncca() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.territorio.territorioArgentina.modalLocalidadeOncca.alertaSelecioneOncca'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t('mensagens.comuns.sim'),
                            cancelButtonText: this.$t(
                                'mensagens.territorio.territorioArgentina.modalLocalidadeOncca.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.dadoSelecionado = null;
                        this.filtro = '';
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarLista = false;
            }, 300);
        },

        async realizarPesquisaOncca() {
            this.pesquisandoOncca = true;
            this.$emit('realizarPesquisaOncca', this.filtro);
            this.pesquisandoOncca = false;
        }
    }
};
</script>

<style lang="scss">
#modal-selecionar-localidade-oncca {
    footer {
        display: flex;
        justify-content: space-between;
    }
    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }
    label {
        margin: 0 !important;
    }

    .informar-car-manualmente-car {
        display: flex;
        margin-top: 24px;
        gap: 5px;
        align-items: center;
        flex-wrap: wrap;
        background-color: #e7e7e7;
        border-radius: 5px;
        padding: 8px 8px;
        min-height: 6px;
    }
    .barra-pesquisa_input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }

    .barra-pesquisa {
        height: 100%;
        display: flex;
        justify-content: center;

        i.el-icon-search,
        i.el-icon-loading {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }
    }
}
.modal-selecionar-localidade-oncca-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }
    .el-dialog__headerbtn {
        top: 10px;
    }
    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }
}
</style>
